<ng-template #companyModalFormMore role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="moreFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="moreFormSubmit()" [formGroup]="moreForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="mb-1">
            <label for="companyName-field" class="form-label">Company Name</label>
          </div>
        </div>  
        <div class="col-6">
          <div class="mb-1">
            <input readonly type="text" id="companyName-field" class="form-control text-end border-0" placeholder="" formControlName="companyName" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="mb-1">
            <label for="companyId-field" class="form-label">Company ID</label>
          </div>
        </div>  
        <div class="col-6">
          <div class="mb-1">
            <input readonly type="text" id="companyId-field" class="form-control text-end border-0" placeholder="" formControlName="companyId" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="mb-4">
            <label for="inviewCompanyId-field" class="form-label">Inview Company ID</label>
          </div>
        </div>  
        <div class="col-6">
          <div class="mb-4">
            <input readonly type="text" id="inviewCompanyId-field" class="form-control text-end border-0" placeholder="" formControlName="inviewCompanyId" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-3">
          <div class="d-grid gap-2">
            <span class="d-grid" [title]="killCompanyHint">
              <button
                type="button"
                id="killCompanyButton"
                class="btn btn-soft-primary inline-block"
                [disabled]="killCompanyDisabled"
                [ngClass]="{ 'btn-soft-danger': highlightBtnKillCompany }"
                (click)="killCompany()"
                (mouseover)="killCompanyMouseOver()"
                (mouseleave)="killCompanyMouseLeave()"
              >
                Remove Company
              </button>
            </span>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      
      @if (curUser.systemAdmin) {
        <div class="row">
          <div class="col-12">
            <div class="form-check form-switch form-switch-md">
              <label class="form-check-label" for="killSureSimOnly-field">Remove from SureSIM Only</label>
              <input class="form-check-input" type="checkbox" role="switch" id="killSureSimOnly-field" formControlName="killSureSimOnly" (click)="killSureSimOnlyClick()">
            </div>
          </div>
        </div>
      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="moreFormCancel()">Close</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-confirmation-modal-form #killCompanyConfirmationModal
  (modalYes)="yesKillCompany()"
></app-confirmation-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
